import { createContext } from 'react';

interface IProductsPageContext {
  analyticsIntersectionObserver: IntersectionObserver | undefined;
}

export default createContext<IProductsPageContext>({
  analyticsIntersectionObserver: undefined,
});
